// Path: src\Components\Popup\SpinTheWheel.jsx
import WheelComponent from "../../Components/Popup/More/WheelComponent";
import Popup from "./BasePopup";
import Coinsgroup from "../../images/Coins Group.png";
import { useEffect, useState } from "react";
import { CoPresentOutlined } from "@mui/icons-material";
import { toastError } from "../../Utilities/toast";
import { t } from "i18next";

export default function App({ isOpen, title, onClose, data,onRewardWin }) {
  const [rewardsList, setRewardsList] = useState([]);
  useEffect(() => {
    var temp = [];
    data?.map((item, index) => {
      const color = index % 2 === 0 ? 'white' : '#EE2737';
      temp.push({ ...item, color: color });
    });
    setRewardsList(temp);
  }, [data]);
  const onFinished = (winner) => {
    console.log(winner);
    // if(winner?.rewardAmount < 1){
    //   toastError(t('errors.error_better_luck_next_time'));
    // }
    setTimeout(() => {
      onRewardWin(winner)  
    },600);
    
  };

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>

      <div className="App spin-the-wheel--wrap">
        <div className="spin-the-wheel-title">to claim exciting rewards</div>
        <div className="coins-group">
          <img className="" src={Coinsgroup} alt="coins"></img>
        </div>
        <div>
          {rewardsList.length > 0 ?
            <WheelComponent
              segments={rewardsList}
              winningSegment="MM"
              onFinished={(winner) =>onFinished(winner) }
              primaryColor="#white"
              contrastColor="#2F3043"
              buttonText="Start"
              isOnlyOnce={false}
              size={190}
              upDuration={500}
              downDuration={600}
              fontFamily="Vi"
            />
            : <></>}
        </div>
      </div>

    </Popup>
  );
}
